/**
 * Arcanist page loader — ported from assets/js/loader.js (PHP).
 * Holds #page-loader for 3s (homepage + password coming-soon), pauses GSAP global timeline, then reveals header.
 */
(function () {
  var LOADER_HOLD_MS = 3000;

  var loader = document.getElementById("page-loader");
  var skipLoader =
    document.documentElement.getAttribute("data-arcanist-skip-loader") === "true" ||
    document.querySelector(".arcanist-password__message--success, .arcanist-password__message--error");

  try {
    if (sessionStorage.getItem("arcanist-skip-password-loader") === "1") {
      skipLoader = true;
      sessionStorage.removeItem("arcanist-skip-password-loader");
    }
  } catch (e) {}

  if (skipLoader) {
    if (loader) loader.remove();
    document.documentElement.classList.remove("loader-active");
    if (window.gsap) gsap.globalTimeline.resume();
    var header = document.getElementById("site-header");
    if (header) {
      header.classList.remove("arcanist-header--hidden");
      header.style.transform = "";
      header.style.opacity = "";
    }
    if (window.ScrollTrigger) ScrollTrigger.refresh();
    return;
  }

  if (loader) {
    var holdOverride = loader.getAttribute("data-loader-hold-ms");
    if (holdOverride) {
      var parsedHold = parseInt(holdOverride, 10);
      if (!isNaN(parsedHold) && parsedHold > 0) LOADER_HOLD_MS = parsedHold;
    }
  }
  var header = document.getElementById("site-header");

  if (loader && window.gsap) gsap.globalTimeline.pause();

  if (loader) {
    var loaderVideo = loader.querySelector("video");
    if (loaderVideo) {
      loaderVideo.muted = true;
      loaderVideo.defaultMuted = true;
      loaderVideo.setAttribute("muted", "");
      loaderVideo.setAttribute("playsinline", "");
      loaderVideo.setAttribute("webkit-playsinline", "");
      var playPromise = loaderVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }
  }

  function unlockScroll() {
    document.documentElement.classList.remove("loader-active");
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  }

  function revealHeader() {
    if (!header) return;
    header.classList.remove("arcanist-header--hidden");
    header.style.transform = "";
    header.style.opacity = "";
  }

  function hideLoader() {
    if (!loader) {
      revealHeader();
      unlockScroll();
      if (window.gsap) gsap.globalTimeline.resume();
      return;
    }

    var video = loader.querySelector("video");
    if (video) video.pause();
    loader.remove();
    if (window.gsap) gsap.globalTimeline.resume();
    revealHeader();
    unlockScroll();
  }

  if (loader) {
    setTimeout(hideLoader, LOADER_HOLD_MS);
  } else {
    hideLoader();
  }
})();
